import RestApiModel from "@/api/Model/RestApiModel";

class Production extends RestApiModel {
  static getResourceEndpoint() {
    return '/PolicyProduction';
  }
}

export default Production;
